const dataLayer = window.dataLayer || [];

const gtmEvents = {
  deviceDeleteInstallation: 'deviceDeleteInstallation',
};

const DevicesDeactivateModalController = (
  $scope,
  $uibModalInstance,
  installation,
  $state,
  installationsService,
  gettextCatalog,
  devicesService,
  $uibModal,
) => {
  'ngInject';

  $scope.installation = installation;

  const handleError = (error) => {
    let errorMsg = gettextCatalog.getString('An error occurred while deactivating the device.');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = `${
          error.data.message
        } ${error.status.toString()} - ${error.statusText.toString()}`;
      } else {
        errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
      }
    } else {
      errorMsg += `. ${gettextCatalog.getString('Please try again later')}.`;
    }
    $scope.errorFlag = true;
    $scope.errorText = errorMsg;
    $scope.deleting = false;
  };

  $scope.ok = () => {
    $scope.errorFlag = false;

    devicesService
      .getDeviceModelBySerialNumber($scope.installation.device.serialNumber)
      .then((response) => {
        // if the device modem is CDMA then it is a verizon unit, verizon needs two modal popups
        if (response.data.modem === 'cdma') {
          $uibModalInstance.close();

          $uibModal.open({
            animation: true,
            template: require('./deactivate.modal.modal.html'),
            controller: 'DevicesDeactivateModalModalController',
            resolve: {
              installation: () => $scope.installation,
            },
            size: 'md',
          });
        } else {
          $scope.deleting = true;

          dataLayer.push({
            event: gtmEvents.deviceDeleteInstallation,
            data: {
              installation: $scope.installation.id,
              serialNumber: $scope.installation.device.serialNumber,
            },
          });

          installationsService.deleteInstallation($scope.installation.id).then(() => {
            $scope.$emit('deviceDeactivated');
            $uibModalInstance.close();
            $state.go('devices2.base');
          }, handleError);
        }
      }, handleError);
  };

  $scope.cancel = () => {
    $uibModalInstance.close();
  };

  $scope.$on('$locationChangeStart', () => {
    $scope.cancel();
  });
};

export default DevicesDeactivateModalController;
